import { cn } from "#lib/utils"
import * as React from "react"

export interface StepListProps extends React.ComponentProps<"ol"> {
  variant?: "default" | "compact"
}

export interface StepItemProps extends React.ComponentProps<"li"> {
  step?: number
}

export function StepList({ variant = "default", className, children, ...props }: StepListProps) {
  return (
    <ol className={cn("space-y-4", variant === "compact" && "space-y-3", className)} {...props}>
      {children}
    </ol>
  )
}

export function StepItem({ step, className, children, ...props }: StepItemProps) {
  return (
    <li className={cn("flex gap-4", className)} {...props}>
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold text-sm">
        {step}
      </div>
      <div className="flex-1 pt-1">{children}</div>
    </li>
  )
}
